/**
 * @file components/BottomSubmit
 * @description 表单底部提交按钮区域
 * @author xuemin02
 */

import React, {ReactNode} from 'react';
import _ from 'lodash';
import {Button} from 'acud';
import classnames from 'classnames';

import {ButtonProps} from 'acud/lib/button';

import {ACUD_PRO_PREFIX} from '../../_common/constants';

import './index.less';

export const BOTTOM_SUBMIT_PREFIX_CLS = `${ACUD_PRO_PREFIX}-bottom-submit`;


export interface BottomSubmitOptions extends ButtonProps {
    text: ReactNode;
}

export interface BottomSubmitProps {
    options?: BottomSubmitOptions[];
    className?: string;
}

const BottomSubmit: React.FC<BottomSubmitProps> = props => {
    const {options = [], className} = props;

    const bottomSubmitCls = classnames(BOTTOM_SUBMIT_PREFIX_CLS, className);

    return (
        <div className={bottomSubmitCls}>
            <div className={`${BOTTOM_SUBMIT_PREFIX_CLS}-box`}>
                {_.map(options, (option, index) => {
                    const {text, ...buttonProps} = option;
                    return (
                        <Button size="large" {...buttonProps} key={index}>
                            {text}
                        </Button>
                    );
                })}
            </div>
        </div>
    );
};

export default BottomSubmit;
